// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminStreaming = (client) => ({
    /**
     * `POST /admin/streaming/download`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPostStreamingDownload
     * @source packages/medusa-plugin-streaming-media/src/api/admin/streaming/download/route.ts
     */
    download: (body, query, headers) => client.fetch("/admin/streaming/download", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/streaming/preview`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPostStreamingPreview
     * @source packages/medusa-plugin-streaming-media/src/api/admin/streaming/preview/route.ts
     */
    preview: (body, query, headers) => client.fetch("/admin/streaming/preview", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/streaming/releases/:id/withdraw`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPostStreamingReleaseWithdraw
     * @source packages/medusa-plugin-streaming-media/src/api/admin/streaming/releases/[id]/withdraw/route.ts
     */
    updateReleasesWithdraw: (id, body, query, headers) => client.fetch(buildPath("/admin/streaming/releases/:id/withdraw", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/streaming/session`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminPostStreamingSession
     * @source packages/medusa-plugin-streaming-media/src/api/admin/streaming/session/route.ts
     */
    updateSession: (body, query, headers) => client.fetch("/admin/streaming/session", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=streaming.js.map